import React from "react";
import { Link } from "react-router-dom";
import Billing from "../Billings/Billing";
import Expenses from "./Expenses";
import ForApproval from "./ForApproval";
import EmployeeClockIns from "./EmployeeClockIns";

function Finance() {
  const [activeLink, setActiveLink] = React.useState("Billing");

  const tabs = [
    // { name: "Overview", link: "/overview" },
    // { name: "Transactions", link: "/transactions" },
    // { name: "Reports", link: "/reports" },
    // { name: "Settings", link: "/settings" },
    // { name: "Invoices", link: "/invoices" },
    // { name: "Payments", link: "/payments" },
    // { name: "Budgets", link: "/budgets" },
    { name: "Billing", link: "/billing" },
    { name: "Expenses", link: "/expenses" },
    { name: "Employee Clock Ins", link: "/employee-clock-ins" },
    // { name: "Taxes", link: "/taxes" },
    { name: "For Approval", link: "/approval-inbox" },
  ];
  return (
    <div className="max-w-7xl mx-auto px-4 py-6 text-xs">
      <h1 className="title-header">Finance</h1>

      {/* tabs */}
      <div className="links-container mt-4">
        {tabs.map((tab, index) => (
          <div key={index}>
            <div
              className={
                activeLink === tab.name
                  ? "activeLinkStyle"
                  : "inactiveLinkStyle"
              }
              onClick={() => setActiveLink(tab.name)}
            >
              {tab.name}
            </div>
          </div>
        ))}
      </div>

      {/* render finance section */}
      <div className="finance-section mt-4">
        {activeLink === "Billing" && <Billing />}
        {activeLink === "Expenses" && <Expenses />}
        {activeLink === "Employee Clock Ins" && <EmployeeClockIns />}
        {/* {activeLink === "Taxes" && <div>Taxes Section</div>} */}
        {activeLink === "For Approval" && <ForApproval />}
      </div>
    </div>
  );
}

export default Finance;
